import type { BillingCycle, Plan, PlanId } from '@/types'

// Plan order is the tier order and also the fixed categorical color order used by every chart
export const PLANS: Plan[] = [
    {
        id: 'starter',
        name: 'Starter',
        price: 199000,
        annualPrice: 159000,
        includedSeats: 3,
        seatPrice: 0,
        description: 'Untuk usaha kecil yang baru mulai go digital.',
        features: ['Hingga 3 pengguna', 'Laporan penjualan dasar', 'Integrasi QRIS', 'Dukungan via email'],
        color: 'var(--chart-3)'
    },
    {
        id: 'growth',
        name: 'Growth',
        price: 549000,
        annualPrice: 439000,
        includedSeats: 5,
        seatPrice: 49000,
        description: 'Untuk bisnis berkembang dengan tim yang aktif.',
        features: ['5 pengguna, bisa ditambah', 'Analitik lengkap', 'Hingga 3 cabang', 'Dukungan chat prioritas'],
        color: 'var(--chart-2)'
    },
    {
        id: 'scale',
        name: 'Scale',
        price: 1490000,
        annualPrice: 1190000,
        includedSeats: 20,
        seatPrice: 39000,
        description: 'Untuk perusahaan dengan banyak cabang dan integrasi.',
        features: ['20 pengguna termasuk', 'Akses API dan webhook', 'Cabang tanpa batas', 'Manajer akun khusus'],
        color: 'var(--chart-4)'
    },
    {
        id: 'enterprise',
        name: 'Enterprise',
        price: 4900000,
        annualPrice: 3900000,
        includedSeats: 50,
        seatPrice: 29000,
        description: 'Untuk korporasi dengan kebutuhan keamanan khusus.',
        features: ['50+ pengguna dan SSO', 'SLA 99,9% dan audit log', 'Integrasi ERP kustom', 'Pendampingan onboarding'],
        color: 'var(--chart-1)'
    }
]

export const PLAN_IDS: PlanId[] = PLANS.map((plan) => plan.id)

export const getPlan = (id: PlanId): Plan => PLANS.find((plan) => plan.id === id) ?? PLANS[0]

export const computeMrr = (planId: PlanId, cycle: BillingCycle, seats: number, overrides?: Partial<Pick<Plan, 'price' | 'annualPrice'>>): number => {
    const plan = getPlan(planId)
    const price = overrides?.price ?? plan.price
    const annualPrice = overrides?.annualPrice ?? plan.annualPrice
    const base = cycle === 'annual' ? annualPrice : price
    const extraSeats = Math.max(0, seats - plan.includedSeats)
    const seatCost = extraSeats * plan.seatPrice * (cycle === 'annual' ? 0.8 : 1)

    return Math.round((base + seatCost) / 1000) * 1000
}
